<template>
   <div id="idAgregarClienteExtraCostoModal">
        <Button
            :size="15"
            color="#2da44e"
            colorText="#ffffff"
            tooltip="Agregar proveedor"
            icon="fas fa-plus"
            round
            :width="30"
            class="mr-2"
            traslate
            @click.native="actionSetShowModalAgregarClienteExtraCostoModal(true)"
        />

        <ui-modal 
            ref="modal" 
            title="Agregar Cliente Extra Costo"
            transition="scale-up"
            size="large"
            @close="actionSetShowModalAgregarClienteExtraCostoModal(false)"
        >
            <div class="w-100">

                <fieldset-component texto="Datos Tarifa Cliente Extra Costo" />

                <div class="d-flex pt-2">

                    <ui-select
                        class="col-12 mt-2"
                        label="Clientes"
                        hasSearch
                        searchPlaceholder="Buscar"
                        placeholder="Seleccionar Cliente"
                        :keys="keys"
                        :options="clientsList"
                        v-model="id_client" 
                    />
                
                </div>

                <div class="d-flex pt-2">

                    <div class="form-group col-4">

                        <date-picker
                            placeholder="Vigencia"
                            type="date"
                            class="w-100"
                            value-type="format"
                            v-model="vigency"
                        />

                    </div>

                    <ui-select
                        class="col-4 mt-2"
                        label="Tipo contenedor"
                        hasSearch
                        searchPlaceholder="Buscar"
                        placeholder="Seleccionar opción"
                        :keys="keys"
                        :options="containerTypes"
                        v-model="id_container_type"
                    />

                    <ui-select
                        class="col-4 mt-2"
                        label="Tipo Extra Costo"
                        hasSearch
                        searchPlaceholder="Buscar"
                        placeholder="Seleccionar opción"
                        :keys="keys"
                        :options="extraCostTypes"
                        v-model="id_extra_costos_tipo"
                    />

                </div>
                
                        <!-- Fila 2 -->
                <div class="d-flex pt-2">

                    <ui-select
                        class="col-4 mt-2 w-50"
                        label="Tipo Servicio Integral"
                        hasSearch
                        searchPlaceholder="Buscar"
                        placeholder="Seleccionar opción"
                        :keys="keys"
                        :options="servicesTypeList"
                        v-model="id_type_service_integral"
                    />

                  
                   

                </div>


                <div class="w-100" >
                    <Button
                        :width="35"
                        round
                        class="float-left "
                        color="#21831b"
                        colorText="#fff"
                        icon="fas fa-search"
                        title="Buscar"
                        traslate
                        :inactive="btnAction"
                        @click.native="search"
                    />

                    <Button
                        :width="35"
                        round
                        class="float-left ml-2 "
                        color="#21831b"
                        colorText="#fff"
                        icon="far fa-trash-alt"
                        title="Limpiar"
                        traslate
                        :inactive="btnAction"
                        @click.native="clear"
                    />
                </div>

                <fieldset-component texto="Resultados Tarifas Extra Costos" class="mt-5" />

                <new-data-table
                    :check="true"
                    :fila-chekeada="getSelectedRow"
                    :headers="headers"
                    :data="data"
                    :acciones="[]"
                    :max="10"
                    paginacion
                    buscar
                    idtabla="agregar_client_extra_costo_table" 
                />

                <fieldset-component v-if="checks.length > 0 && data.length > 0" texto="Comentarios adicionales" class="mt-3" />

                <div class="d-flex pt-2" v-if="checks.length > 0 && data.length > 0">

                    <div class="form-group col-12">

                        <label>Observaciones</label>
                        <textarea class="form-control"
                                    v-model="comments"
                                    placeholder="Ingrese observaciones"
                                    type="text"
                                    rows="3"
                        />

                    </div>

                    

                </div>

                <Button
                    v-if="checks.length > 0 && data.length > 0"
                    text="Agregar"
                    color="#21831b"
                    :width="100"
                    :height="40"
                    colorText="#fff"
                    icon="far fa-paper-plane"
                    title="Agregar Tarifa Cliente"
                    horizontal
                    @click.native="!btnAction && send()"
                    :inactive="btnAction"
                />
            </div>
        </ui-modal> 

   </div>

</template>

<script>

    // UI Modal
    import UiModal from "keen-ui/src/UiModal";
    import Button from '@/components/common/Button';
    import { mapState, mapActions } from "vuex";
    import FieldsetComponent from '../../../common/FieldsetComponent';
    import DatePicker from "vue2-datepicker";
    import NewDataTable from '../../../common/NewDataTable';
    import { tariffClientsExtraCostoIndex, tariffClientsExtraCostoSearch, tariffClientsExtraCostoStorage } from "../../../../constants/serviciosLogisticos";

    export default {

        data(){
            return {
                id_client : {},
                vigency: "",
                keys : { label: 'name', value: 'id' },
                id_container_type : {},
                id_extra_costos_tipo : {} ,
                id_type_service_integral : {},

                data: [],
                checks: [],
                headers: [
                    "ID",
                    "Desde",
                    "Hasta",
                    "Proveedor",
                    "Tipo Extra Costo",
                    "Moneda",
                    "Valor Total",
                    "Tipo Contenedor",
                    "Observaciones"
                ],
                btnAction: false,

                comments: ""

            }
        },

        components: {
            UiModal,
            Button,
            FieldsetComponent,
            DatePicker,
            NewDataTable
        },

        computed: {
            ...mapState("serviciosLogisticos", [
                "showModalAgregarClienteExtraCostoModal",
                "customersList",
                "listCarriers",
                "servicesTypeList",
                "clientsList",
                "listCurrencies",
                "extraCostTypes",
                "unityPayments",
                "containerTypes",
             ])
        },
        methods : {

            ...mapActions([ "ActionSetZindexTablaModal"]),

            ...mapActions("serviciosLogisticos",[
                 "actionSetShowModalAgregarClienteExtraCostoModal",
                 "actionSetShowLoadingClienteExtraCosto",
                 "actionSetDataTableClienteExtraCosto"
                ]),


            openModal(ref) {
                this.ActionSetZindexTablaModal(true);

                this.$refs[ref].open();
            },
            
            closeModal(ref) {
                this.$refs[ref].close();
                this.ActionSetZindexTablaModal(false);
            },
            cerrarModal(){
                this.closeModal('modal');
            },

            clear (){
                this.id_client =  {};
                this.vigency = "";
                this.id_container_type =  {};
                this.id_extra_costos_tipo =  {} ;
                this.id_type_service_integral =  {};

                this.data = [];

                this.comments = "";
            },
            async getSelectedRow({ id , estado, accion }) {

                switch ( accion ) {

                    case "fila_chekeada":{
                        estado 
                        ? this.checks.push( id )
                        : this.checks = this.checks.filter( c => c != id ) ;
                    }
                    break ;
                }
            },

            valid(){

                if( ! this.id_client.id ){
                    this.$vToastify.warning("Campo Cliente Obligatorio", "Alerta");
                    return false ;
                }

                if( ! this.vigency ){
                    this.$vToastify.warning("Campo Vigencia Obligatorio", "Alerta");
                    return false ;
                } 

                if( ! this.id_container_type.id ){
                    this.$vToastify.warning("Campo Tipo Contenedor Obligatorio", "Alerta");
                    return false ;
                }

                if( ! this.id_extra_costos_tipo.id ){
                    this.$vToastify.warning("Campo Tipo Extra Costo Obligatorio", "Alerta");
                    return false ;
                }

                if( ! this.id_type_service_integral.id ){
                    this.$vToastify.warning("Campo Tipo Servicio Integral Obligatorio", "Alerta");
                    return false ;
                }

                return true ;
            },
            formatData( data ){
                return data.map( d => ({
                    data : [
                        d.id,
                        d.from,
                        d.to ,
                        d.name_carrier ,
                        d.name_extra_costos_tipos,
                        d.code_currency,
                        d.value,
                        d.name_type_container,
                        d.comments
                    ],
                    data_complementaria: d
                })) ;
            },
            async search(){

                if( ! this.valid() ) return ;

                this.$vToastify.loader("Buscado Proveedores Extra Costo...");

                const payload = {
                    id_client : this.id_client.id ?? null ,
                    id_container_type : this.id_container_type.id ?? null ,
                    id_extra_costos_tipo : this.id_extra_costos_tipo.id ?? null ,
                    id_type_service_integral : this.id_type_service_integral.id ?? null ,
                    vigency : !this.vigency ? null : this.vigency ,
                };

                try {
                    
                    const { data } = await tariffClientsExtraCostoSearch( payload );

                    if( data.length == 0 ){
                        this.data = [] ;
                        this.$vToastify.stopLoader();
                        return this.$vToastify.warning("No se Encontraron Tarifas para Proveedores Extra Costo.", "Alerta");
                    } 
                    this.data = this.formatData( data );

                    this.$vToastify.stopLoader();

                } catch (error) {

                    this.data = [] ;
                    this.$vToastify.stopLoader();
                    return this.$vToastify.error("No se Encontraron Tarifas para Proveedores Extra Costo.", "Error");
                }
            },
            async send(){

                if( this.checks.length == 0 ) return this.$vToastify.warning( "Debe Seleccionar Tarifa", "Alerta");

                const data = this.checks.map( c => this.data[c] ) ;

                this.btnAction = true ;
                const payload = data.map( ({ data_complementaria }) => ({
                    id_tariff_provider_extra_cost : data_complementaria.id ?? null,
                    id_client : this.id_client.id ?? null,
                    value : data_complementaria.value ?? null,
                    comment : !this.comments ? null : this.comments,
                    id_tier : data_complementaria.id_tier
                }));

                this.$vToastify.loader("Agregando Tarifa Cliente Extra Costo...");

                try {
                    
                    await tariffClientsExtraCostoStorage( payload );

                    this.$vToastify.stopLoader();

                    this.$vToastify.success("Se ha agregado tarifa correctamente", "Éxito");

                    this.clear() ;

                    this.btnAction = false ;

                    this.rechargeTable() ;

                    return this.actionSetShowModalAgregarClienteExtraCostoModal(false) ;

                } catch (error) {

                    this.btnAction = false ;

                    this.$vToastify.stopLoader();

                    return this.$vToastify.error("No se Encontraron Tarifas para Proveedores Extra Costo.", "Error");
                }
            },
            async rechargeTable(){
            
                this.actionSetShowLoadingClienteExtraCosto( true );

                const { data } = await tariffClientsExtraCostoIndex() ;

                this.actionSetDataTableClienteExtraCosto( data ) ;

                this.actionSetShowLoadingClienteExtraCosto( false );
            },
        },
        watch: {
            showModalAgregarClienteExtraCostoModal: function( _new ){
                _new ? this.openModal("modal") : this.cerrarModal() ;
            }
        }

    }

</script>

<style>

#idAgregarClienteExtraCostoModal .mx-input {
    padding-left: 2px !important;
    border-radius: 0 !important;
    border: none !important;
    border-bottom: 1px solid #dcdcdc !important;
    box-shadow: none !important;
    margin-top: 26px;
}
</style>